import { IIdNameItem } from './IdNameItem';
import { ISliderConfig } from './sliderConfig';
import { ILeasingSearchResult } from './leasingSearchResult';

// tslint:disable: variable-name
/**
 * It gathers the leasing form data for a car criteria:
 *  - selected options: both the id and the name are saved (for example make id and make name)
 *  - available options (for example, makes and models)
 *
 * When setting a field, its very next field must be reset. For example, when setting the make, the model is reset.
 */
export class LeasingCarCriteria {

    private _contractLengthSliderConfig: ISliderConfig = new ISliderConfig();
    private _contractLength: number;
    private _contractMileageSliderConfig: ISliderConfig = new ISliderConfig();
    private _contractMileage: number;
    private _make: IIdNameItem;
    private _model: IIdNameItem;
    private _bodyType: IIdNameItem;
    private _fuelType: IIdNameItem;
    private _services: IIdNameItem[] = [];
    private _additionalInformation: string = '';

    searchResult: ILeasingSearchResult;
    makes: IIdNameItem[] = [];
    allMakeModels: IIdNameItem[] = [];
    models: IIdNameItem[] = [];
    bodyTypes: IIdNameItem[] = [];
    fuelTypes: IIdNameItem[] = [];
    serviceOptions: IIdNameItem[] = [];

    get contractLengthSliderConfig(): ISliderConfig {
        return this._contractLengthSliderConfig;
    }

    set contractLengthSliderConfig(sliderConfig: ISliderConfig) {
        this._contractLengthSliderConfig = sliderConfig;
    }

    get contractLength(): number {
        return this._contractLength;
    }

    set contractLength(contractLength: number) {
        this._contractLength = contractLength;
    }

    get contractMileageSliderConfig(): ISliderConfig {
        return this._contractMileageSliderConfig;
    }

    set contractLMileageSliderConfig(sliderConfig: ISliderConfig) {
        this._contractMileageSliderConfig = sliderConfig;
    }

    get contractMileage(): number {
        return this._contractMileage;
    }

    set contractMileage(contractMileage: number) {
        this._contractMileage = contractMileage;
    }

    get make(): IIdNameItem {
        return this._make;
    }

    set make(make: IIdNameItem) {
        this._make = make;
    }

    get model(): IIdNameItem {
        return this._model;
    }

    set model(model: IIdNameItem) {
        this._model = model;
    }

    get bodyType(): IIdNameItem {
        return this._bodyType;
    }

    set bodyType(bodyType: IIdNameItem) {
        this._bodyType = bodyType;
    }

    get fuelType(): IIdNameItem {
        return this._fuelType;
    }

    set fuelType(fuelType: IIdNameItem) {
        this._fuelType = fuelType;
    }

    get services(): IIdNameItem[] {
        return this._services;
    }

    set services(services: IIdNameItem[]) {
        this._services = services;
    }

    get serviceNameAsString() {
        const serviceNames = this._services.map(service => {
            return service.name;
        });
        return serviceNames.join(', ');
    }

    get additionalInformation(): string {
        return this._additionalInformation;
    }

    set additionalInformation(additionalInformation: string) {
        this._additionalInformation = additionalInformation;
    }
}
